export default    [
  {
    "name": "P_4",
    "type": "input",
    "label": "Nombres y Apellidos",
    "required": true,
    "inputType": "default",
    "maxLength": 50,
    "help": "gesshhhhsh"
  },
  {
    "name": "P_5",
    "type": "input",
    "label": "Email",
    "required": true,
    "inputType": "email",
    "maxLength": 50,
    "help": "hshhdhd"
  },
  {
    "name": "P_3",
    "type": "input",
    "label": "Cedula",
    "required": true,
    "inputType": "number",
    "maxLength": 20,
    "help": "hshdd6u65u"
  },
  {
    "name": "P_7",
    "type": "boolean",
    "label": "Registrado",
    "required": true,
    "help": "hrdjdrtjdrj"
  },
  {
    "name": "P_8",
    "type": "multiChoice",
    "label": "Selección multiple",
    "required": true,
    "options": [
      "Grado",
      "Pregrado",
      "Doctorado"
    ],
    "help": "vzrgregsgser",
    "related": {
      "answer": true,
      "name": "P_7",
      "question": 3,
      "relatedness": "simple"
    }
  }
]